import { render, staticRenderFns } from "./OrderPaymentDetail.vue?vue&type=template&id=023ecbbb&scoped=true&"
import script from "./OrderPaymentDetail.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderPaymentDetail.vue?vue&type=style&index=0&id=023ecbbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023ecbbb",
  null
  
)

export default component.exports